import React, { useRef, useEffect } from 'react';
import NotifyMe from './NotifyMe';
import PreOrder from './PreOrder';
import AddToCart from './AddToCart';
import { useIdPrefix } from '@jbhi-fi/components/src/IdPrefix';
import { CheckAvailability } from './CheckAvailability';

export type CTAProps = {
  buttonType?: string;
  className?: string;
  product?: any;
  productCartData?: any;
  gtmProduct?: any;
  variantAvailable?: boolean;
  isDigital?: boolean;
  setIsCtaVisible?: (value: boolean) => void;
  trackButton?: boolean;
  isProductCard?: boolean;
  trackingListName?: string | null;
  productCategoryHierarchy?: Array<string>;
  quantity?: number;
  checkAvailabilityAction?: () => void;
};

export const CTAButton = (props: CTAProps): JSX.Element => {
  const visibilityRef = useRef(null);
  const { trackButton = false, setIsCtaVisible, className, product } = props;

  useEffect(() => {
    if (setIsCtaVisible && trackButton && visibilityRef.current) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          setIsCtaVisible(true);
        } else if (entry.boundingClientRect.y <= 0) {
          setIsCtaVisible(false);
        } else {
          setIsCtaVisible(true);
        }
      });
      const visibilityRefVar = visibilityRef.current;
      observer.observe(visibilityRefVar);
      return () => observer.unobserve(visibilityRefVar);
    }
  }, [visibilityRef]);

  const { buttonType } = props;

  return (
    <div id={useIdPrefix('addtocart-cta')} className={className} ref={visibilityRef}>
      {buttonType === 'Buy' && <AddToCart {...props} />}
      {buttonType === 'PreOrder' && <PreOrder {...props} />}
      {buttonType === 'NotifyMe' && (
        <NotifyMe productTitle={product?.title} productId={product?.id} variantId={product?.variants[0].id} />
      )}
      {buttonType === 'CheckAvailability' && <CheckAvailability {...props} />}
    </div>
  );
};
